<template>

      <div class="title">
        {{$t('library.steps.icon_color.icon_title')}}
      </div>
      <div class="p-mb-5 p-mt-2 p-d-flex p-flex-wrap">
        <div v-for="i in 75" :key="('icon_'+i)" 
            :class="['p-mr-2 p-mb-2 box-icon p-d-flex p-ai-center p-jc-center',{'selected':(i-1)===image}]"
            @click="imageClick(i-1)">
          <span :class="'icon-mf_cycle_image_'+(i-1).toString().padStart(4, '0')" style="font-size: 45px" />
        </div>
      </div>

      <div class="title">
        {{$t('library.steps.icon_color.color_title')}}
      </div>
      <div class="p-mb-5 p-mt-2 p-d-flex p-flex-wrap">
        <div v-for="(value, key, index) in colors" :key="('color_'+index)" 
            :class="['p-mr-2 p-mb-2 box-color p-d-flex p-ai-center p-jc-center',{'selected':(key)==color},{'none':(key)==0}]"
            @click="colorClick(key)">
          <div :class="['p-d-flex p-ai-center p-jc-center']"
            :style="('background-color: '+value.hex)">
            <span v-if="(key>0 && key==color)" class="icon-success" style="font-size: 30px" />
            <span v-if="(key==0)" class="half-cross" />
          </div>
        </div>
      </div>

</template>

<script>
import cyclesMF from "../../../../public/json/cycles_mf.json";
export default {
  emits: ['update:color','update:image','update:headerButtonHidden'],
  components: {
    },
    props: {
      color: Number,
      image: Number
    },
    data() {
        return {
          colors: cyclesMF.colors
        };
    },
    computed: {
    },
    created() {
    },
    mounted() {
      this.validation();
    },
    watch: {
      color: 'validation',
      image: 'validation',
    },
    methods: {
      validation() {
        this.$emit("update:headerButtonHidden", !(this.color >=0 && this.image >=0) );
      },
      colorClick(newColor) {
        this.$emit("update:color", { color: parseInt(newColor) });
      },
      imageClick(newImage) {
        this.$emit("update:image", { image: newImage });
      },
    }

}
</script>

<style scoped>
</style>